import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_react-dom@19.0.0_react@19.0.0__react@19.0.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/blog/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/vercel/path0/src/blocks/common/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkEmbedClient"] */ "/vercel/path0/src/blocks/common/LinkEmbed/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuoteClient"] */ "/vercel/path0/src/blocks/common/Quote/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostAuthorInfo"] */ "/vercel/path0/src/components/BlogPostAuthorInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostSocialSharing"] */ "/vercel/path0/src/components/BlogPostSocialSharing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/vercel/path0/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/vercel/path0/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/vercel/path0/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostCard"] */ "/vercel/path0/src/components/PostCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/vercel/path0/src/components/Section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Shard"] */ "/vercel/path0/src/components/Shard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/src/components/ui/label.tsx");
